import { whitelistedEndpoints } from './whitelistedEndpoints'

const isSafeUrlOverrideFromTests = (urlFromTestsOrFileVersion: string) =>
	whitelistedEndpoints.some((endpoint) => urlFromTestsOrFileVersion.startsWith(endpoint))

export const getEditorElementsAssetUrl = (urlFromTestsOrFileVersion: string, fileRepoUrl: string): string =>
	isSafeUrlOverrideFromTests(urlFromTestsOrFileVersion)
		? urlFromTestsOrFileVersion
		: `${fileRepoUrl}/services/editor-elements/dist/${urlFromTestsOrFileVersion}`
